
import React, { useContext, useEffect, useState } from "react";
import WebServiceContext from "../WebService/ServiceContext";
import { BasicContext } from '../context/BasicContext'

type AnswerBtnsProp = {
    serial: number
    qName: string
    QSNo: number
    jsonString: string
    defAns?: string
    showAns?: boolean
    checker: () => {} | void
}

type AnswerItem = {
    ItemID: string,
    ItemTitle: string,
    ansID: string,
}


export default (props: AnswerBtnsProp) => {
    //const ws = useContext(WebServiceContext)
    const bc = useContext(BasicContext)

    const [btns, setBtns] = useState<AnswerItem[]>([])
    const [current, setCurrent] = useState<string>("")

    const writeAns = ()=>{
        
    }

    useEffect(() => {
        if (props) {
            setBtns(JSON.parse(props.jsonString) as AnswerItem[])
            if (props.defAns) {
                setCurrent(props.defAns)
            }
           // console.log(JSON.parse(props.jsonString))
            console.log(props)
        }
    }, [props])


    
    /*處理BasicContext 中 回答問題的列表 */
    /*
    useEffect(() => {
        if(bc.ansList.length > 0){
            bc.ansList.map((item:ResAnswers)=>{
                console.log(item as ResAnswers)
            })
        
        }
    },[bc.ansList])
    */
    //console.log("init")

    /**
     * 
     * 
     *   /*if (props.defAns) {
                            if (a.ItemID == props.defAns) {
                                return (
                                    <div key={"ans-" + index}>
                                        您的回答：{a.ItemTitle}
                                    </div>
                                )
                        }
                        if (props.showAns) {
                            //console.log(bc.ansList)
                            let myAns:string="";
                            bc.ansList.map((item: ResAnswers) => {
                                if (a.ItemID == item.ItemID) {
                                    myAns = a.ItemTitle
                                }
                            })
                            if( myAns!=""){
                                return (
                                    <div key={"ans-" + index}>
                                    您的回答：{a.ItemTitle}
                                </div>
                            )
                        }

                        } else {
    */
    if (btns && btns.length > 0 && !props.showAns) {
        return (
            <div style={{ marginBottom: 60 }}>
                {
                    btns.length > 0 &&
                    btns.map((a: AnswerItem, index: number) => {
                        return (
                            <button
                                key={"btn-" + index}
                                className={"hibBtn dot " + (a.ItemID == current ? "active" : "white")}
                                onClick={() => {
                                    setCurrent(a.ItemID)
                                    const ans: ResAnswers = {
                                        QSNo: props.QSNo.toString(),
                                        qtxt: props.qName,
                                        ItemID: a.ItemID,
                                        ansTxt: a.ItemTitle
                                    }

                                    let temp: ResAnswers[] = bc.ansList;
                                    temp[props.serial] = ans
                                    bc.setAnsList(temp)
                                    props.checker()
                                }}
                            >
                                {a.ItemTitle}
                            </button>
                        )

                    })
                }
            </div>
        )
    } else if (props.showAns == true) {
        let myAns:string=""
        bc.ansList.map((a:ResAnswers)=>{
            if(a.QSNo == props.QSNo.toString()){
                //console.log(a)
                myAns = a.ansTxt as string
            }
        })
        
        return (
            <div style={{ marginBottom: 60 }}>
                您的回答：
                <span className="answer">
                    {myAns!=""? myAns:"NAN"}
                </span>
                
            </div>
        )
    } else {
        return (<span>...loading</span>)
    }
}

